export class FeedbackFormConstants {
    static PROBABILITY_OF_SHOWING_FEEDBACK_FORM = 0.1
    static DAYS_BETWEEN_FEEDBACK_FORMS = 90
}
